(function() {
  'use strict';

  // ブラウザ環境チェック
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  // モダンアコーディオン（Vanilla JS）
  function initModernAccordion() {
    const accordions = document.querySelectorAll('.c-accordion');
    if (accordions.length === 0) return;

    accordions.forEach(accordion => {
      const toggle = accordion.querySelector('.c-accordion__toggle');
      const body = accordion.querySelector('.c-accordion__body');

      if (!toggle || !body) return;

      // 初期状態で閉じる
      body.style.height = '0';
      body.style.overflow = 'hidden';
      body.style.transition = 'height 0.3s ease';

      toggle.addEventListener('click', function(e) {
        e.preventDefault();

        const isOpen = accordion.classList.contains('is-active');

        if (isOpen) {
          // --- 閉じる ---
          accordion.classList.remove('is-active');
          toggle.classList.remove('is-active');

          body.style.height = body.scrollHeight + 'px';

          // 強制リフロー
          body.offsetHeight;

          body.style.height = '0';
        } else {
          // --- 開く ---
          accordion.classList.add('is-active');
          toggle.classList.add('is-active');

          body.style.height = body.scrollHeight + 'px';

          // 開き終わったら auto に戻す
          const transitionHandler = function(e) {
            if (e.propertyName === 'height') {
              body.style.height = 'auto';
              body.removeEventListener('transitionend', transitionHandler);
            }
          };
          body.addEventListener('transitionend', transitionHandler);
        }
      });
    });
  }

  // jQuery版アコーディオン
  function initJQueryAccordion() {
    // jQueryの存在確認
    if (typeof window.jQuery === 'undefined') return;

    window.jQuery(document).ready(function($) {
      const jsAccElements = $('.js-acc');
      if (jsAccElements.length === 0) return;

      // 初期状態：すべての該当ボディを非表示に
      $('.js-acc__body').hide();

      // イベント委任で、.js-acc 自体または内部のトグル要素をクリックしたときに対応
      // トグルになりうるセレクタ（例）：.js-acc, .js-acc--open, .js-acc--open の子要素（.inner, .contents__head など）
      jsAccElements.on('click', '.js-acc, .js-acc--open, .js-acc--open * , .js-acc--open, .js-acc__toggle, .js-acc--open', function(e) {
        // クリック元が body 内部の場合は無視する（body 内のリンクなどを阻害しない）
        const $target = $(e.target);
        if ($target.closest('.js-acc__body').length) return;

        // 最寄りの .js-acc 要素を探す
        const $acc = $(this).closest('.js-acc');
        if ($acc.length === 0) return;

        e.preventDefault();

        // まずは同じブロック内のボディを探す（子要素として存在するケース）
        let $body = $acc.find('> .js-acc__body');

        // 見つからない場合は、トグルの直後の兄弟要素を探すケース（例: .js-acc をクリックして next が body）
        if ($body.length === 0) {
          $body = $acc.next('.js-acc__body');
        }

        // 更に見つからない場合は、ブロック内のどこかに存在する js-acc__body を探す
        if ($body.length === 0) {
          $body = $acc.find('.js-acc__body');
        }

        // トグル状態の切り替え
        $acc.toggleClass('js-acc--open is-active');
        $body.stop(true, true).slideToggle(400);

        return false;
      });
    });
  }

  // jQuery版アコーディオン（data属性連携版）
  function initScoopAccordion() {
    // jQueryの存在確認
    if (typeof window.jQuery === 'undefined') return;

    window.jQuery(document).ready(function($) {
      const scopeToggleElements = $('.scoop_js-acc--open');
      if (scopeToggleElements.length === 0) return;

      // 初期状態：すべてのscoop_js-acc__bodyを非表示
      $('.scoop_js-acc__body').hide();

      scopeToggleElements.on('click', function(e) {
        e.preventDefault();

        const $toggle = $(this);

        // data-target属性から対象のIDを取得
        const targetId = $toggle.data('target');
        let $targetBody;

        if (targetId) {
          // data-target指定がある場合：IDで検索
          $targetBody = $('#' + targetId);
        } else {
          // data-target指定がない場合：クラス名で最も近い要素を検索
          const targetClass = $toggle.data('body-class') || 'scoop_js-acc__body';
          $targetBody = $toggle.closest('.scoop_js-acc').find('.' + targetClass);

          // 親要素内に見つからない場合は、同じレベルで検索
          if ($targetBody.length === 0) {
            $targetBody = $toggle.siblings('.' + targetClass);
          }
        }

        if ($targetBody.length === 0) return;

        // トグル状態の切り替え
        $toggle.toggleClass('is-active');
        $targetBody.slideToggle(400);

        return false;
      });
    });
  }

  // 安全な初期化
  function safeInit() {
    try {
      initModernAccordion();
      initJQueryAccordion();
      initScoopAccordion();
    } catch (error) {
      console.warn('Accordion initialization error:', error);
    }
  }

  // DOMContentLoaded イベントリスナーの安全な追加
  if (document.readyState === 'loading') {
    // addEventListenerが関数であることを確認
    if (typeof document.addEventListener === 'function') {
      document.addEventListener('DOMContentLoaded', safeInit);
    } else {
      // 古いブラウザ対応
      if (document.attachEvent) {
        document.attachEvent('onreadystatechange', function() {
          if (document.readyState === 'complete') {
            safeInit();
          }
        });
      } else {
        // フォールバック
        setTimeout(safeInit, 100);
      }
    }
  } else {
    // DOM既に読み込み済み
    safeInit();
  }

})();
